import { createApp } from 'vue';
import AppMobileCDN from '../apps/AppMobileCDN.vue'
import Clarity from '@microsoft/clarity'

Clarity.init('x5txpfp38i')

createApp(AppMobileCDN)
  .mount('#app');